module.exports = __webpack_public_path__ + "img/ic_exercise_default.a6fe41b9.png";